const PageNotFound = () => {
    return (
        <h1>Page not Found</h1>
    )
}

export default PageNotFound;